module.exports = __webpack_public_path__ + "static/img/program_12.e9b0287.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/program_12.jpg
// module id = Gbs3
// module chunks = 0